import PropTypes from 'prop-types'

const TARIFF_FEATURE_BOOKING_TYPES = {
    ONETIME: 'ONETIME',
    RECURRING: 'RECURRING'
}

/**
 * @typedef {Object} BookedFeatures
 * @property {string}   [accountId]                   - The identifier of the account that is associated with the booking
 * @property {string}   [billingStartDate]            - The billing start date for the booking
 * @property {string}   [bookingNo]                   - The booking number of the related feature booking record (WfBillRecurringCustomerBooking)
 * @property {string}   [consumeTime]                 - The termination date for the booking
 * @property {string}   [contractId]                  - The identifier for the associated contract
 * @property {string}   [contractNo]                  - The number of the associated contract
 * @property {string}   [customerCurrency]            - The currency of the customer (e.g. 'EUR')
 * @property {string}   [customerId]                  - The id of the customer
 * @property {string}   [deviceSerialNo]              - The serial number of the device that is associated with the booking
 * @property {string}   [featureClass]                - The class of the feature
 * @property {string}   [featureMetaDataId]           - The identifier of the related feature data record (WfFeatureMetaData)
 * @property {string}   [featureTypeId]               - The identifier of the related feature type
 * @property {string}   [featureTypeName]             - The internal name of the feature type
 * @property {string}   [id]                          - The identifier of the additional WF feature (WfBillRecurringCustomerBooking)
 * @property {boolean}  [isDiyReadOnly]               - Flag indicating if the feature is read-only (no booking, terminating, assigning)
 * @property {string}   [name]                        - The name of the additional WF feature
 * @property {string}   [objectId]                    - The identifier of the vehicle
 * @property {string}   [objectName]                  - The name of the vehicle
 * @property {string}   [objectNo]                    - The number of the vehicle
 * @property {number}   [price]                       - The price for the feature booking
 * @property {number}   [smartBundleId]               - The smart bundle id
 * @property {string}   [stringcode]                  - The string code for the additional WF feature
 * @property {string}   [tariff]                      - The tariff name of the unit
 * @property {string}   [tariffFeatureBookingType]    - The tariff feature booking type
 * @property {string}   [tariffGroupId]               - The identifier for the group the tariff belongs to
 * @property {string}   [unitId]                      - The identifier of the unit
 * @property {string}   [unitType]                    - The technical code for the unit type
 * @property {string}   [unitTypeTranslated]          - The translated unit type
 * @property {string}   [validFrom]                   - The date the booking is valid from
 * @property {string}   [validTo]                     - The date the booking is valid to
 */
export const bookedFeaturePropType = PropTypes.shape({
    accountId: PropTypes.string,
    billingStartDate: PropTypes.string,
    bookingNo: PropTypes.string,
    consumeTime: PropTypes.string,
    contractId: PropTypes.string,
    contractNo: PropTypes.string,
    customerCurrency: PropTypes.string,
    customerId: PropTypes.string,
    deviceSerialNo: PropTypes.string,
    featureClass: PropTypes.string,
    featureMetaDataId: PropTypes.string,
    featureTypeId: PropTypes.string,
    featureTypeName: PropTypes.string,
    id: PropTypes.string,
    isDiyReadOnly: PropTypes.bool,
    name: PropTypes.string,
    objectId: PropTypes.string,
    objectName: PropTypes.string,
    objectNo: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.object)]),
    smartBundleId: PropTypes.number,
    stringcode: PropTypes.string,
    tariff: PropTypes.string,
    tariffFeatureBookingType: PropTypes.oneOf(Object.values(TARIFF_FEATURE_BOOKING_TYPES)),
    tariffGroupId: PropTypes.string,
    unitId: PropTypes.string,
    unitType: PropTypes.string,
    unitTypeTranslated: PropTypes.string,
    validFrom: PropTypes.string,
    validTo: PropTypes.string
})
